module.exports = __webpack_public_path__ + "static/media/ic_plus_column.dbceb315.svg";